/**
 * Mutación para setear e programa de accidentes mayores.
 */
export function setProgram(state, data) {
    state.program.id = data.id;
    state.program.tittle = data.tittle;
    state.program.active = data.active;
}

/**
 * Mutación para setear las secciones del programa de accidentes mayores.
 */
export function setSections(state, sections) {
    state.sections = sections;
}

/**
 * Mutación para setear la seccion de accidentes mayores.
 */
export function setSection(state, data) {
    state.section = data;
}

/**
 * Mutación para setear la sub seccion de accidentes mayores.
 */
export function setSubSection(state, data) {
    state.sub_section = data;
}

/**
 * Mutación para setear la tabla de accidentes mayores.
 */
export function setTable(state, data) {
    state.table = data;
}


/**
 * Mutación para limpiar la seccion de accidentes mayores.
 */
export function clearSection(state) {
    state.section = {
        id: null,
        code: null,
        tittle: null,
        active: null,
        description: null,
        slq_program_accident_id: null,
        sub_sections: []
    };
}

